// extracted by mini-css-extract-plugin
export default {"TalkSectionContainer":"TalkSection_TalkSectionContainer__Ga-qQ"};